document.addEventListener("DOMContentLoaded", function () {
  function toMenu() {
    const menuLink = document.getElementById("menu");

    if (menuLink) {
      window.location.href = menuLink.dataset.link;
    }
  }

  window.toMenu = toMenu;
});
